import React from "react";
import ModalImage from "react-modal-image";

export default function CustomModalImage({ src, className }) {
  return <ModalImage alt=" " className={className} small={src} large={src} />;
}
